export default "<h3>January 27, 2019</h3>\r\n<p>Update 0.71 fixes some bugs.</p>";